import { useMsal } from '@azure/msal-react';
import { Grid, TextField, Typography } from '@mui/material';
import { useContext } from 'react';
import TenantContext from '../../lib/context/TenantContext';
import useUserRole from '../activeUser';

const UserProfile = () => {
  const { accounts } = useMsal();
  const { tenant } = useContext(TenantContext);
  const userRole = useUserRole(); // Use the custom hook to get the user role

  return (
    <div>
      <Typography variant='h4' fontWeight='bold' color={'black'}>
        Hi, {accounts?.[0]?.name}
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant='h6' fontWeight='bold'>
            Email Id
          </Typography>
          <TextField
            value={accounts?.[0]?.username || ''}
            variant='outlined'
            fullWidth
            disabled
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant='h6' fontWeight='bold'>
            Company
          </Typography>
          <TextField
            value={tenant?.name || ''}
            variant='outlined'
            fullWidth
            disabled
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant='h6' fontWeight='bold'>
            Role
          </Typography>
          <TextField
            value={userRole || 'Loading...'}
            variant='outlined'
            fullWidth
            disabled
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default UserProfile;
